import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Tooltip, Button, Modal, Divider, message } from "antd";
import { QuestionCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { format, findDeep, getDevicePluginDetail } from "@/utils";
import api from "@/api";
import { publicPath } from "@/utils/base";

const { confirm } = Modal;
import dataJson from "@/../public/data.json";

const prefix = "myDevicePluginDetail-info";
import "./index.less";

function Info() {
  const { my_device_plugin_detail, confirmText, cancelText, release, delete_text } = dataJson;

  const [devicePluginMapping, setDevicePluginMapping] = useState<any>();

  const navigate = useNavigate();
  const { id } = useParams();

  const devicePluginDetail = useSelector((state: any) => state.devicePluginDetail);

  const handleDelete = () => {
    confirm({
      title: delete_text + my_device_plugin_detail?.detail_title,
      icon: null,
      width: 328,
      centered: true,
      closable: true,
      closeIcon: <CloseOutlined />,
      okText: confirmText,
      cancelText: cancelText,
      content: (
        <div className="delete-modal-content">
          {my_device_plugin_detail.app_delete_content1}&quot;{devicePluginMapping?.name}&quot;
          {my_device_plugin_detail.app_delete_content2}
        </div>
      ),
      onOk: async () => {
        try {
          const res: any = await api.deleteDevicePlugin({ ids: [id] });

          if (res?.code == 200) {
            navigate(`${publicPath}/my_device_plugin`);
          } else {
            message.error(res.msg);
          }
        } catch (errorInfo: any) {
          console.error(errorInfo);
        }
      },
    });
  };

  useEffect(() => {
    if (devicePluginDetail) {
      const firstTwo = devicePluginDetail.histories.slice(0, 2);
      const isDel = firstTwo.every((item: any) => {
        const resShowMode = findDeep(release.show_mode_arr, item.showMode);
        return resShowMode?.baseBtns?.includes("delete");
      });

      const resDataCopy = {
        ...devicePluginDetail,
        createTimeText: format(new Date(Number(devicePluginDetail?.createTime)), "yyyy年MM月dd日 HH:mm:ss"),
        isDel,
      };

      setDevicePluginMapping(resDataCopy);
    }
  }, [devicePluginDetail]);

  useEffect(() => {
    getDevicePluginDetail(id);
  }, []);

  return (
    <div className={prefix}>
      <div className={`${prefix}-inner`}>
        <div className={`${prefix}-header`}>
          <div className={`${prefix}-header-text`}>
            <div className={`${prefix}-header-title`}>{my_device_plugin_detail.detail_title_text}</div>
            <div className={`${prefix}-header-tip`}>{my_device_plugin_detail.info_tip}</div>
          </div>
          <div className={`${prefix}-header-btns`}>
            <Button
              className={`${prefix}-content-delete`}
              disabled={!devicePluginMapping?.isDel}
              onClick={handleDelete}
            >
              {delete_text + my_device_plugin_detail?.detail_title}
            </Button>
          </div>
        </div>
        <div className={`${prefix}-content`}>
          <div className={`${prefix}-content-title`}>{my_device_plugin_detail.developer_title}</div>
          <div className={`${prefix}-content-developer`}>
            <Tooltip
              placement="bottomLeft"
              title={my_device_plugin_detail.developer_tip}
              overlayClassName={`${prefix}-content-developer-tooltip`}
              color="#fff"
              overlayInnerStyle={{
                color: "rgba(0,0,0,0.8)",
                width: 200,
                padding: "10px 16px",
                transform: "translate(-12px, 0)",
              }}
            >
              <QuestionCircleOutlined style={{ color: "#0A59F7", cursor: "pointer", fontSize: 14 }} />
            </Tooltip>
            <div className={`${prefix}-content-developer-id`}>
              <span>{my_device_plugin_detail.developer_ID}</span>
              {devicePluginMapping?.developerId}
            </div>
          </div>
          <Divider />
          <div className={`${prefix}-content-title mt-title`}>{my_device_plugin_detail.detail_title}</div>
          <div className={`${prefix}-content-value`}>
            <span>{my_device_plugin_detail.package_type}</span>
            {my_device_plugin_detail.package_type_text}
          </div>

          <div className={`${prefix}-content-value`}>
            <span>{my_device_plugin_detail.device_plugin_ID}</span>
            {devicePluginMapping?.id}
          </div>
          <div className={`${prefix}-content-value`}>
            <span>{my_device_plugin_detail.create_time}</span>
            {devicePluginMapping?.createTimeText}
          </div>

        
        </div>
      </div>
    </div>
  );
}

export default Info;
